import axios from 'axios'
import endpoints from './endpoints'
const fetchCsConsultantWework = async ({params}) => {

  const {substation_id} = params

  if (!substation_id) {
    throw new Error('Error fetchConsultantWework(): No substation_id provided')
  }

  try {
    const url = endpoints.repair
    const res = await axios.get(`${url}?substation_id=${params.substation_id}&uid=${params.uid}`)

    // console.log(res)

    return res
  }
  catch (error) {
    throw new Error(error)
  }
}

export {fetchCsConsultantWework}
